// eslint-disable-next-line no-restricted-imports

import * as React from 'react';
import TextTruncate from 'react-text-truncate';
import { Box, Paragraph } from '@99designs/emu';
import { Button } from '@99designs/frontend-components/components/Button';

interface ExpandableTextProps {
    text: string;
    expandLabel: string;
    onExpand?: () => void;
    isExpanded: boolean;
}

export default function ExpandableText({
    isExpanded,
    text,
    onExpand,
    expandLabel,
}: ExpandableTextProps) {
    return (
        <>
            <Box marginBottom="0.5bu">
                {isExpanded ? (
                    <Paragraph as="div" size="small" data-testid="expandable-text" data-qm-block>
                        {text}
                    </Paragraph>
                ) : (
                    <Paragraph as="div" size="small" data-testid="expandable-text" data-qm-block>
                        <TextTruncate line={2} truncateText="…" text={text} />
                    </Paragraph>
                )}
            </Box>
            <Button variations={['link']} onClick={onExpand}>
                <Paragraph as="div" size="small">
                    {expandLabel}
                </Paragraph>
            </Button>
        </>
    );
}
